import { NetworkIntegrityJobStatus } from "@app/projects/enumerators";
export enum NetworkIntegrityJobAction {
  IsJobLoadingChanged = "IS_JOB_LOADING_CHANGED",
  JobStatusChanged = "JOB_STATUS_CHANGED",
};

export type NetworkIntegrityJobActions =
  { type: NetworkIntegrityJobAction, value: NetworkIntegrityJobState };

export interface NetworkIntegrityJobState {
  canResubmit?: boolean;
  isAdequacyImpactExpected?: boolean;
  isAdequacyImpactProcessing?: boolean;
  isJobLoading?: boolean;
  isOpportunityServiceArea?: boolean;
  jobStatus?: NetworkIntegrityJobStatus;
};

export const networkIntegrityJobInitialState = (): NetworkIntegrityJobState => Object.freeze({
  canResubmit: undefined,
  isAdequacyImpactExpected: undefined,
  isAdequacyImpactProcessing: undefined,
  isJobLoading: true,
  isOpportunityServiceArea: undefined,
  jobStatus: undefined
});

export const networkIntegrityJobReducer = (state: NetworkIntegrityJobState, action: NetworkIntegrityJobActions): NetworkIntegrityJobState => {
  switch (action.type) {
    case NetworkIntegrityJobAction.IsJobLoadingChanged:
      return Object.freeze({
        ...state,
        isJobLoading: action.value.isJobLoading,
      });
    case NetworkIntegrityJobAction.JobStatusChanged:
      return Object.freeze({
        ...state,
        canResubmit: action.value.canResubmit,
        isAdequacyImpactExpected: action.value.isAdequacyImpactExpected,
        isAdequacyImpactProcessing: action.value.isAdequacyImpactProcessing,
        isOpportunityServiceArea: action.value.isOpportunityServiceArea,
        jobStatus: action.value.jobStatus,
      });
    default:
      return state;
  }
};